import React, { Component } from "react";

class Resume extends Component {
  render() {
    return (
      <section id="resume" className="resume">
        <div className="container">
          <div className="section-title">
            <h2>Resume</h2>
            {/* <p>
              Magnam dolores commodi suscipit. Necessitatibus eius consequatur
              ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam
              quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea.
              Quia fugiat sit in iste officiis commodi quidem hic quas.
            </p> */}
          </div>

          <div className="row">
            <div className="col-lg-6" data-aos="fade-up">
              <h3 className="resume-title">Sumary</h3>
              <div className="resume-item pb-0">
                <h4>Akshay Nahar</h4>
                <p>
                <em>
                    Innovative and deadline-driven Software Developer with 1.5+
                    years of experience designing and developing user-centered
                    Softwares from initial concept to
                    final, polished deliverable.
                  </em>
                  <br />
                  <br />
                  <em>
                    <b>OBJECTIVE</b>: To pursue a challenging career in a
                    progressive environment where learning, innovation, and
                    creativity are encouraged, where my skills and knowledge can be
                    enhanced to their maximum potential to contribute to the overall
                    success and growth of the organization.
                  </em>
                 
                </p>
                <ul>
                  <li>36,Mahaveer Nagar, BJNR(Ajmer) Raj, Bharat</li>
                  <li>+(91) 90015-35885</li>
                  <li>naharakshay8@gmail.com</li>
                </ul>
              </div>

              <h3 className="resume-title">Education</h3>
              <div className="resume-item">
                <h4>Bachelor of Technology &amp; Computer Science</h4>
                <h5>2015 - 2019</h5>
                <p>
                  <em>Rajasthan Technical University, Kota, Raj.</em>
                </p>
                <p>
                  Graduated from the Rajasthan
                  Technical University in
                  Computer Science Engineering
                  with 71.87 % in 2019 with Honours divison.
                </p>
              </div>
              <div className="resume-item">
                <h4>High Secondary &amp; Science Mathematics</h4>
                <h5>2014 - 2015</h5>
                <p>
                  <em>Narayan se. sec school, BJNR, Ajmer, Raj.</em>
                </p>
                <p>
                  Completed high school from
                  the Board of Secondary
                  Education Rajasthan in PCM
                  with 72.80 %.
                </p>
              </div>

            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <h3 className="resume-title">Professional Experience</h3>
              <div className="resume-item">
                <h4>Associate Software Development</h4>
                <h5>2019 - Present</h5>
                <p>
                  <em>Sevina Technologies, Ahemdabad, GJ</em>
                </p>
                <ul>
                  <li>
                    Programming our proprietary software products to
                    implement new features and support current applications.
                  </li>
                  <li>
                    Monitor everyday activities of the system and provide the
                    required support.
                  </li>
                  <li>
                    Additional responsibilities include being part of a
                    collaborative team that produces a quality product for our
                    clients, Perform problem analysis determination, code
                    design, and development, integration, test, modification.
                  </li>
                  {/* <li>
                  </li> */}
                </ul>
              </div>
              <h3 className="resume-title">Intrenship &amp; Training </h3>
              <div className="resume-item">
                <h4>Intern in Dotnet Development</h4>
                <h5>2019</h5>
                <p>
                  <em>B.L. Soni, Bhilwara, Raj.</em>
                </p>
                <ul>
                  <li>
                    Prepare &amp; maintain code for various dotnet application
                    upgrading, configuring, and debugging existing systems
                  </li>
                </ul>
              </div>
              <div className="resume-item">
                <h4>Trainee in Android Development</h4>
                <h5>2018</h5>
                <p>
                  <em>TechienestIn pt. Ltd, Jaipur, Raj.</em>
                </p>
                <ul>
                  <li>
                    Designing and developing applications for the android
                    platform unit-testing code for robustness, usability, and
                    general reliability.
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Resume;
